var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 6.11111C45.3307 6.11111 35.8785 8.97839 27.8388 14.3504C19.7991 19.7224 13.5328 27.3578 9.83256 36.291C6.13227 45.2243 5.16411 55.0542 7.0505 64.5378C8.93689 74.0213 13.5931 82.7324 20.4303 89.5697C27.2676 96.4069 35.9787 101.063 45.4623 102.95C54.9458 104.836 64.7757 103.868 73.709 100.167C82.6423 96.4672 90.2777 90.201 95.6496 82.1612C101.022 74.1215 103.889 64.6693 103.889 55C103.889 42.0339 98.7381 29.5988 89.5697 20.4303C80.4012 11.2619 67.9662 6.11111 55 6.11111Z",
    fill: "#1ECAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5673 36L50.4022 62.3547L38.9018 52.1252L32 59.9698L51.3645 77L83 43.4907L75.5673 36Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.fda95fa999e38f1d2b152863bfb6e9dc.svg";
export { ForwardRef as ReactComponent };